/* eslint-disable react-hooks/rules-of-hooks */
import { MediaLibrary } from 'components/MediaLibrary';
import { getMediaLibrary } from 'lib/graphql/getMediaLibrary';
import { getLocale } from 'modules/localesMapper';
import { GetServerSideProps } from 'next';
import React from 'react';
import { Locale, Markets } from '../../generated/graphql';
import { IGlobalMetaData } from '../../types/GlobalMetadata';
import { ShortHero } from '../../components/ShortHero';
import PageComponentMapper from '../../modules/componentMapping/pageComponentMapper';
import { getGenericPageComponents } from '../../lib/graphql/getGenericPageComponents';
import { DictionaryItem } from '../../types/Dictionary';
import { algoliaPrefixes, facetsKeys } from '../api/webhook';
import getSearchClient from '../../modules/searchClient';
import getConfig from 'next/config';
import { SearchResponse } from '@algolia/client-search';
import Custom404 from '../404';
import { INotificationBannerProps } from '../../components/NotificationBanner/types';

function IndexPage({
  mediaLibraryData,
  locale,
  market,
  serverError,
  pageData,
  dictionary,
}: {
  globalMetadata: IGlobalMetaData;
  locale: Locale;
  market: Markets;
  recallData: INotificationBannerProps;
  mediaLibraryData: SearchResponse;
  pageData: any;
  serverError: boolean;
  dictionary: DictionaryItem[];
}) {
  if (serverError) {
    return <Custom404 dictionary={dictionary} />;
  }

  if (pageData && Array.isArray(pageData)) {
    pageData = pageData[0];
  }

  return (
    <>
      <ShortHero
        data={{
          superTitle: pageData.title,
          title: pageData.subtitle,
          description: pageData.introText,
        }}
      />
      {/* Updating state creates flickering on PageComponentMapper, this is why a separate comp has been created for the media library */}
      <MediaLibrary
        currMarket={market}
        locale={locale}
        copy={dictionary}
        serverMediaLibraryData={mediaLibraryData}
      />
      <PageComponentMapper
        components={pageData.bodyComponents}
        copy={dictionary}
        rewrites={{}}
        apiUrl={''}
      />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  locale = 'global',
  locales,
  res,
  query,
}) => {
  let error = false;
  const slug = 'media-library';
  const market = locale; // locale from path is representing market
  const currLocale = getLocale(market);
  const { publicRuntimeConfig } = getConfig();
  const searchClient = getSearchClient(
    publicRuntimeConfig.algoliaAppId,
    publicRuntimeConfig.algoliaApiKey,
  );

  const rewrites: any[] = [];

  const pageData = await getMediaLibrary(currLocale);

  const index = searchClient.initIndex(algoliaPrefixes['MediaLibrary']);
  const indexSearch = await index.search('', {
    facets: facetsKeys['MediaLibrary'],
    hitsPerPage: 12,
    filters: `locale:${currLocale}`,
  });

  if (pageData.data.page && pageData.data.page.length > 0) {
    pageData.data.page[0].bodyComponents = await getGenericPageComponents(
      pageData.data.page[0].bodyComponents,
      currLocale,
      market,
    );
  }

  return {
    props: {
      locale: currLocale,
      locales,
      rewrites,
      market,
      mediaLibraryData: indexSearch,
      pageData: pageData.data.page,
      metaData: pageData.data.page[0].metaData,
      serverError: error,
    },
  };
};
export default IndexPage;
